import React from 'react'
import styled from 'styled-components'

import TimePicker from '../TimePicker'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
type TTime = {
  startTime?: string
  endTime?: string
}
type TTimeRangePicker = {
  value?: TTime
  onChange?: (val: TTime) => void
}

const TimeRangePicker = (props: TTimeRangePicker): React.ReactElement => {
  const { value, onChange } = props

  const { startTime, endTime } = value || {}

  const setStartTime = (v: string): void => {
    if (onChange) {
      onChange({
        startTime: v,
        endTime,
      })
    }
  }

  const setEndTime = (v: string): void => {
    if (onChange) {
      onChange({
        startTime,
        endTime: v,
      })
    }
  }

  return (
    <Wrapper>
      <TimePicker value={startTime} onChange={setStartTime} />
      <div className="mx-2">-</div>

      <TimePicker value={endTime} onChange={setEndTime} />
    </Wrapper>
  )
}

export default TimeRangePicker
